module.exports = __webpack_public_path__ + "img/hu.b3639aa8.svg";